import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Card, CardBody } from 'reactstrap';
import { fetchKibanaConfig } from './action';
import { toast } from 'react-toastify';
import { trimIframeSource } from './helper';
import { setPageView } from '../../components/GoogleAnalytics/index';

class KibanaDashboard extends Component {
    componentDidMount() {
        this.props.fetchKibanaConfig();
        setPageView('/Corporate/DIYReports', document.location.href);
    }
    componentDidUpdate(prevProps) {
        if (this.props.kibanaConfigDataFailure !== prevProps.kibanaConfigDataFailure) {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Error in Fetching Configurations
                </div>
            );
        }
    }
    render() {
        const tempSource = (this.props.kibanaConfigData) ? trimIframeSource(this.props.kibanaConfigData.reportUrl) : ''
        const iframeTag = (this.props.kibanaConfigData) ?
            <CardBody> <iframe src={tempSource} height="750" width="1040"> </iframe></CardBody> :
            <CardBody><iframe src={tempSource} height="600" width="800"> </iframe></CardBody>
        return (
            <Col>
                <Card>
                    {iframeTag}

                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    kibanaConfigData: state.FetchKibanaConfig.kibanaconfigSuccess,
    kibanaConfigDataFailure: state.FetchKibanaConfig.kibanaconfigFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchKibanaConfig: () => { dispatch(fetchKibanaConfig()) },
});


export default KibanaDashboard = connect(
    mapStateToProps,
    mapDispatchToProps
)(KibanaDashboard)